import React, { createContext, useState, useEffect } from 'react'
import { node } from 'prop-types'

export const SettingsBannerContext = createContext()

export const BannerContext = ({ children }) => {
  const [ reanHashKey, setReanHashKey ] = useState("");
  const [ layerActive, setLayerActive ] = useState([{element: null, type: ""}]);
  const [ reload, setReload ] = useState(false);
  const [ fullScreenLeft, setFullScreenLeft ] = useState(false);
  const [ fullScreenRight, setFullScreenRight ] = useState(false);
  const [ isIABFormat, setIsIABFormat ] = useState(false);
  const [ isIABWeight, setIsIABWeight ] = useState(false);
  const [ isGloboFormat, setIsGloboFormat ] = useState(false);
  const [ isGloboWeight, setIsGloboWeight ] = useState(false);
  const [ globoWeightHosted, setGloboWeightHosted ] = useState('');
  const [ globoWeightTag, setGloboWeightTag ] = useState('');
  const [ animationContainer, setAnimationContainer ] = useState(false);
  const [ loading, setLoading] = useState({show: false, progress: null});
  const [ error, setError ] = useState({lista: [], mensagem: "", show: false}); 
  const [ videoModal, setVideoModal ] = useState(false);
  const [ selectBannerModal, setSelectBannerModal ] = useState(false);
  const [ stepActive, setStepActive ] = useState(null);
  const [ AiAnimation, setAiAnimation ] = useState(null);
  const [ listaBanners, setListaBanners ] = useState({
    master: null,
    listaReplicas: null,
    active: null
  });
  /**
   * @var {'png' | 'jpg'}
   */
  const [backupFormat, setBackupFormat] = useState('png');

  useEffect(() => {
    try {
      const fetchBusinesses = () => {
        setReload(false);
        return true;      
      }
      fetchBusinesses();
    } catch (error) { }
  });

  return (
    <SettingsBannerContext.Provider
      value={{
        layerActive,
        setLayerActive,
        reload,
        setReload,
        fullScreenLeft,
        setFullScreenLeft,
        fullScreenRight,
        setFullScreenRight,
        isIABFormat,
        setIsIABFormat,
        isIABWeight,
        setIsIABWeight,
        isGloboFormat,
        setIsGloboFormat,
        isGloboWeight,
        setIsGloboWeight,
        globoWeightHosted,
        setGloboWeightHosted,
        globoWeightTag,
        setGloboWeightTag,
        loading,
        setLoading,
        animationContainer,
        setAnimationContainer,
        reanHashKey,
        setReanHashKey,
        error,
        setError,
        videoModal, setVideoModal,
        stepActive, setStepActive,
        AiAnimation, setAiAnimation,
        backupFormat, setBackupFormat,
        selectBannerModal, setSelectBannerModal,
        listaBanners, setListaBanners
      }}
    >
      {children}
    </SettingsBannerContext.Provider>
  )
}

SettingsBannerContext.propTypes = {
  children: node.isRequired
}
